// Vue
import { Component, Vue } from "vue-property-decorator";
// Mobx
import { autorun } from "mobx";
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Enums

import "#/modules/index";
import { Api } from "#/api";
import { parsePlaceholderText } from "#/common/Utils";
import { HeadlineNews } from "../../../components/headline_news/HeadlineNews";

@Observer
@Component({
  mixins: [template],
  components: {
    HeadlineNews,
  },
})
export class AufbauplusLayout extends Vue {
  public handleBodyPaddingChanged(padding: number) {
    this.$store.ui.bodyPadding = padding;
  }

  public handleActiveOverlay(overlay) {
    if (overlay) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  public handleFooterClick(itemName: string) {
    // @ts-ignore
    this.$refs["Header"].openPolicy(itemName);
  }

  public handleCookieAccept(accepted: boolean) {
    if (accepted) {
      // @ts-ignore
      window._paq.push(["rememberConsentGiven"]);
    }

    Api.authService.updateTrackingStatus(accepted);
    // @ts-ignore
    this.$refs["CookieLayer"].handleAgree();
  }

  public parseCookieLinkText(text: string, start: string, end: string) {
    return parsePlaceholderText(text, start, end);
  }
}
